import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

export function getApiHeaders(authToken?: string | null): HttpHeaders {
  const headers: any = {
    'Content-Type': 'application/json',
    'x-api-key': environment.apiKey
  };

  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  // Add tenant subdomain header if not localhost
  const hostname = window.location.hostname;
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    const parts = hostname.split('.');
    if (parts.length > 2) {
      headers['X-Tenant-Subdomain'] = parts[0];
    }
  }

  return new HttpHeaders(headers);
}